import { render } from "./OrganisationTable.vue?vue&type=template&id=e9f1b6aa"
import script from "./OrganisationTable.vue?vue&type=script&lang=js"
export * from "./OrganisationTable.vue?vue&type=script&lang=js"

import exportComponent from "/home/rampa/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__